const stripBank = ['https://anchor:', 'http://anchor:'];

const internalBank = ['https://internal:', 'http://internal:'];

export default function linkStripper(link) {
  if (link) {
    let cleanLink = link.replace(/\s/g, '').toLowerCase();
    let cleanedLink = cleanLink;

    stripBank.map((strip, index) => {
      if (cleanLink.includes(strip)) {
        cleanedLink = '#' + cleanLink.split(strip)[1];
      }
    });
    internalBank.map((internalStrip, index) => {
      if (cleanLink.includes(internalStrip)) {
        cleanedLink = cleanLink.split(internalStrip)[1];
        if (cleanedLink.charAt(0) !== '/') {
          cleanedLink = '/' + cleanedLink;
        }
      }
    });
    return cleanedLink;
  } else {
    return link;
  }
}
